import EventBus from "@plugins/common/service/eventbus";

const stpEventBus = new EventBus();
export default stpEventBus;
